export default "__VITE_ASSET__Wcm5Ub$o__"